import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  createOnePassCancelButton: {
    marginLeft: "10px",
  },
  formContainer: {
    justifyContent: "center"
  },
  dialogContent:{
    textAlign: "center", 
    padding: 0
  },
  image:{
     width: "100%", 
     height: "auto", 
     objectFit: "contain"
  }
}));